import { useParams } from 'react-router-dom';
import { t } from '@/lib/i18n';
import { useJobTemplateDetail } from '../hooks';
import { JobTemplateEditor } from '../components/JobTemplateEditor';
import styles from './JobTemplateFormPage.module.css';

/**
 * Routes /library/templates/new, /library/templates/:id (tenant-scoped =
 * editable), and /library/templates/:id (system-scoped = read-only) all to
 * the same unified JobTemplateEditor with the right mode.
 */
export function JobTemplateFormPage() {
  const params = useParams<{ id?: string }>();
  const id = params.id;
  const isNew = !id || id === 'new';

  const detail = useJobTemplateDetail(isNew ? undefined : id);

  if (isNew) {
    return (
      <div className={styles.page}>
        <JobTemplateEditor mode="new" />
      </div>
    );
  }

  if (detail.isLoading) {
    return (
      <div className={styles.page} role="status">
        {t('Loading…')}
      </div>
    );
  }
  if (!detail.data || detail.error) {
    return (
      <div className={styles.page} role="alert">
        {t('This Job Template is not available.')}
      </div>
    );
  }

  const item = detail.data.item;
  const mode = item.kind === 'system' ? 'view' : 'edit';

  return (
    <div className={styles.page}>
      <JobTemplateEditor mode={mode} template={item} />
    </div>
  );
}
